import { GetGoodsSupplyPriceResponse } from '../kymw0900/api-services/get-goods-supply-price.service';
import { GetSelectedNvalMediumListResponse } from '../kymw0900/api-services/get-selected-nval-medium-list.service';
import { KYMW0907Component } from './kymw0907.component';

/**
 * 予約商品設定画面の値を管理するクラス
 *
 * @export KYMW0907Model
 * @class KYMW0907Model
 */
export class KYMW0907Model {
  kymw0907Component: KYMW0907Component;

  // 編集有無フラグ
  public isEdited = false;

  // モード
  public mode: number = 0;

  // 遷移元から受け取る受注コード
  public orderCode = '';

  // 遷移元から受け取るPコード
  public pCode = '';

  // 遷移元から受け取る会員タブのアイテムコードリスト
  public coopInfoItemCode = [];

  // 1物N価詳細情報ID
  public nvalDetailId = '';

  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードリスト
  public itemCodeList = [];

  // アイテムコードリストの活性制御
  public itemCodeListDisable = false;

  // 媒体
  public mediumType = '';

  // 媒体リスト
  public mediumTypeList : GetSelectedNvalMediumListResponse[] = [];

  // 媒体リストの活性制御
  public mediumTypeListDisable = false;

  // アイテムコードに紐づく会員生協リスト
  public itemRelatedCoop_CoopTab = [];

  // 注文コード割当
  public orderNumQuotaCode = '';

  // 注文コード割当リスト
  public orderNumQuotaCodeList = [];

  // 1物N価詳細区分
  public nvalDetailDev = '';

  // 1物N価詳細区分リスト
  public nvalDetailDevList = [];

  // 商品企画担当区分
  public shkkktantKb = '';

  // 専用商品名
  public nvalPromotionGoodsName = '';

  // 専用商品名(カナ)
  public nvalPromotionGoodsNameKana = '';

  // 専用規格名
  public nvalPromotionStandardName = '';

  // 専用規格名(カナ)
  public nvalPromotionStandardNameKana = '';

  // 注文コード
  public orderNum = '';

  // 値引区分
  public discountType = '0';

  // 値引区分リスト
  public discountTypeList = [
    {Code: '0', Name: '値引きなし'},
    {Code: '1', Name: '単価指定'},
    {Code: '2', Name: '率指定'},
  ];

  // 値引率
  public discountRate = '';

  // 値引率リスト
  public setDiscountRateList(): Array<any> {
    let list = [];
    for (let i = 0; i <= 100; i++) {
      list.push({Code: String(i), Name: String(i + '%')});
    }
    return list;
  }
  public discountRateList = this.setDiscountRateList();

  // 供給単価
  public supplyPriceStandard = '';
  
  // 値引単価
  public discountUnitPrice = '';

  // 値引後供給単価
  public discountSupplyUnitPrice = '';

  // 価格パターンコンボボックス用
  public coopSupplyPriceList: GetGoodsSupplyPriceResponse[] = [];

  // 価格パターン 初期値：「0:通常」
  public selectPricePattern = '0';

  // 利用都県:全生協 チェック
  public allCoop = false;
  // 利用都県:全生協 非活性フラグ
  public allCoopDisable = false;

  // 利用都県:い チェック
  public usePrefecture1Flg = false;
  // 利用都県:い 非活性フラグ
  public coopIBDisable = false;

  // 利用都県:と チェック
  public usePrefecture2Flg = false;
  // 利用都県:と 非活性フラグ
  public coopTODisable = false;

  // 利用都県:ぐ チェック
  public usePrefecture3Flg = false;
  // 利用都県:ぐ 非活性フラグ
  public coopGUDisable = false;

  // 利用都県:ち チェック
  public usePrefecture4Flg = false;
  // 利用都県:ち 非活性フラグ
  public coopTIDisable = false;

  // 利用都県:さ チェック
  public usePrefecture5Flg = false;
  // 利用都県:さ 非活性フラグ
  public coopSADisable = false;

  // 利用都県:とう チェック
  public usePrefecture6Flg = false;
  // 利用都県:とう 非活性フラグ
  public coopTKDisable = false;

  // 利用都県:な チェック
  public usePrefecture7Flg = false;
  // 利用都県:な 非活性フラグ
  public coopNADisable = false;

  // 利用都県:に チェック
  public usePrefecture8Flg = false;
  // 利用都県:に 非活性フラグ
  public coopNIDisable = false;

  // 備考
  public remarks = '';

  // 追加フラグ
  public registFlg = '0';

  // 削除フラグ
  public deleteFlg = '0';
}
